<h1 matDialogTitle>Pay Invoice with Deposit</h1>

<mat-dialog-content>

  <div>
    <table style="width: 100%;">
      <tr>
        <th class="th-label">Invoice</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.invoiceNumber}}</td>
        <th class="th-label">Balance</th>
        <td class="td-value" style="text-align: right;">{{invoice.invoiceBalance | number:'1.2-2'}}</td>
      </tr>
      <tr>
        <th class="th-label">Deposit</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.salesOrderNumber}}</td>
        <th class="th-label">Balance</th>
        <td class="td-value" style="text-align: right;">{{invoice.depositBalance | number:'1.2-2'}}</td>
      </tr>

    </table>
  </div>


  <form class="dynamic-form" [formGroup]="form" style="width: 100%;margin-top: 32px;">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="0px grid">

      <!-- TODO add store -->

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Amount</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="amount">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [disabled]="busy" matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid || busy" (click)="save()">Save</button>
</mat-dialog-actions>
